const STARS_GROUP = () => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M3.85691 4.39281C3.14811 4.39281 2.57129 3.75473 2.57129 2.97064C2.57129 2.70896 2.37974 2.49658 2.14276 2.49658C1.90577 2.49658 1.71422 2.70896 1.71422 2.97064C1.71422 3.75473 1.1374 4.39281 0.4286 4.39281C0.191618 4.39281 6.10352e-05 4.60518 6.10352e-05 4.86686C6.10352e-05 5.12854 0.191618 5.34092 0.4286 5.34092C1.1374 5.34092 1.71422 5.979 1.71422 6.76309C1.71422 7.02477 1.90577 7.23714 2.14276 7.23714C2.37974 7.23714 2.57129 7.02477 2.57129 6.76309C2.57129 5.979 3.14811 5.34092 3.85691 5.34092C4.09389 5.34092 4.28545 5.12854 4.28545 4.86686C4.28545 4.60518 4.09389 4.39281 3.85691 4.39281Z"
      fill="#FFBC00"
    />
    <path
      opacity="0.8"
      d="M8.56992 10.5554C7.86112 10.5554 7.28431 9.91732 7.28431 9.13324C7.28431 8.87156 7.09275 8.65918 6.85577 8.65918C6.61879 8.65918 6.42723 8.87156 6.42723 9.13324C6.42723 9.91732 5.85042 10.5554 5.14161 10.5554C4.90463 10.5554 4.71307 10.7678 4.71307 11.0295C4.71307 11.2911 4.90463 11.5035 5.14161 11.5035C5.85042 11.5035 6.42723 12.1416 6.42723 12.9257C6.42723 13.1874 6.61879 13.3997 6.85577 13.3997C7.09275 13.3997 7.28431 13.1874 7.28431 12.9257C7.28431 12.1416 7.86112 11.5035 8.56992 11.5035C8.80691 11.5035 8.99846 11.2911 8.99846 11.0295C8.99846 10.7678 8.80691 10.5554 8.56992 10.5554Z"
      fill="#FFBC00"
    />
    <path
      d="M11.443 3.06543C10.5215 3.06543 9.77168 2.23593 9.77168 1.21661C9.77168 0.876432 9.52266 0.600342 9.21458 0.600342C8.9065 0.600342 8.65748 0.876432 8.65748 1.21661C8.65748 2.23593 7.90762 3.06543 6.98618 3.06543C6.6781 3.06543 6.42908 3.34152 6.42908 3.68171C6.42908 4.02189 6.6781 4.29798 6.98618 4.29798C7.90762 4.29798 8.65748 5.12748 8.65748 6.1468C8.65748 6.48698 8.9065 6.76307 9.21458 6.76307C9.52266 6.76307 9.77168 6.48698 9.77168 6.1468C9.77168 5.12748 10.5215 4.29798 11.443 4.29798C11.7511 4.29798 12.0001 4.02189 12.0001 3.68171C12.0001 3.34152 11.7511 3.06543 11.443 3.06543Z"
      fill="#FFBC00"
    />
  </svg>
);

export default STARS_GROUP;
